import { FC } from 'react';
import { ErrorTemplate } from '@/components/ErrorTemplate';
import { Waiting } from '@/components/Loading';
import { SingleFundSections } from './components/SingleFundSections';
import { useSetBackUrl } from '@/hooks/backUrl';
import { useScrollToTopOnMount } from '@/hooks/scroll';
import { useHandleRequiredServices } from './hooks/useHandleRequiredServices';

const SingleFundModule: FC = () => {
  useSetBackUrl('/invest/fund');
  useScrollToTopOnMount();

  const { isLoading, isError, isFetching, refetchOnError } =
    useHandleRequiredServices();

  if (isLoading) {
    return <Waiting isFullHeight />;
  }

  if (isError) {
    return <ErrorTemplate isLoading={isFetching} onRefetch={refetchOnError} />;
  }

  return <SingleFundSections />;
};

export default SingleFundModule;
